import { DeleteOutlined, HeartOutlined, MessageOutlined, ShoppingCartOutlined, StarOutlined, SyncOutlined, QuestionCircleOutlined } from '@ant-design/icons';
import { Button, Form, Input, message, Modal, notification, Space, Table, TableColumnsType, Tag, Tooltip, Select, Tour, ConfigProvider } from 'antd';
import type { TourProps } from 'antd';
import dayjs from 'dayjs';
import React, { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import OrdersModal from '../components/OrdersModal';
import FavoritesModal from '../components/FavoritesModal';
import { userService } from '../services/userService';
import type { User } from '../types/users';
import { configService } from '../services/configService';
import axios from 'axios';
import Icon from '@ant-design/icons';
import type { CustomIconComponentProps } from '@ant-design/icons/lib/components/Icon';
import AdminLayout from '../components/AdminLayout';
import '../styles/AdminPages.css';
import viVN from 'antd/locale/vi_VN';

const { Option } = Select;
const { TextArea, Search } = Input;

const TAG_OPTIONS = [
    { label: 'Hội viên', value: 'Hội viên' },
    { label: 'Quan tâm', value: 'Quan tâm' },
    { label: 'Chưa có', value: '' }
];

const ZaloIcon = (props: Partial<CustomIconComponentProps>) => (
    <Icon
        component={() => (
            <svg width="50" height="50" viewBox="0 0 50 50" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path fill-rule="evenodd" clip-rule="evenodd" d="M22.782 0.166016H27.199C33.2653 0.166016 36.8103 1.05701 39.9572 2.74421C43.1041 4.4314 45.5875 6.89585 47.2557 10.0428C48.9429 13.1897 49.8339 16.7347 49.8339 22.801V27.1991C49.8339 33.2654 48.9429 36.8104 47.2557 39.9573C45.5685 43.1042 43.1041 45.5877 39.9572 47.2559C36.8103 48.9431 33.2653 49.8341 27.199 49.8341H22.8009C16.7346 49.8341 13.1896 48.9431 10.0427 47.2559C6.89583 45.5687 4.41243 43.1042 2.7442 39.9573C1.057 36.8104 0.166016 33.2654 0.166016 27.1991V22.801C0.166016 16.7347 1.057 13.1897 2.7442 10.0428C4.43139 6.89585 6.89583 4.41245 10.0427 2.74421C13.1707 1.05701 16.7346 0.166016 22.782 0.166016Z" fill="#0068FF" />
                <path opacity="0.12" fill-rule="evenodd" clip-rule="evenodd" d="M49.8336 26.4736V27.1994C49.8336 33.2657 48.9427 36.8107 47.2555 39.9576C45.5683 43.1045 43.1038 45.5879 39.9569 47.2562C36.81 48.9434 33.265 49.8344 27.1987 49.8344H22.8007C17.8369 49.8344 14.5612 49.2378 11.8104 48.0966L7.27539 43.4267L49.8336 26.4736Z" fill="#001A33" />
                <path fill-rule="evenodd" clip-rule="evenodd" d="M7.779 43.5892C10.1019 43.846 13.0061 43.1836 15.0682 42.1825C24.0225 47.1318 38.0197 46.8954 46.4923 41.4732C46.8209 40.9803 47.1279 40.4677 47.4128 39.9363C49.1062 36.7779 50.0004 33.22 50.0004 27.1316V22.7175C50.0004 16.629 49.1062 13.0711 47.4128 9.91273C45.7385 6.75436 43.2461 4.28093 40.0877 2.58758C36.9293 0.894239 33.3714 0 27.283 0H22.8499C17.6644 0 14.2982 0.652754 11.4699 1.89893C11.3153 2.03737 11.1636 2.17818 11.0151 2.32135C2.71734 10.3203 2.08658 27.6593 9.12279 37.0782C9.13064 37.0921 9.13933 37.1061 9.14889 37.1203C10.2334 38.7185 9.18694 41.5154 7.55068 43.1516C7.28431 43.399 7.37944 43.5512 7.779 43.5892Z" fill="white" />
                <path d="M20.5632 17H10.8382V19.0853H17.5869L10.9329 27.3317C10.7244 27.635 10.5728 27.9194 10.5728 28.5639V29.0947H19.748C20.203 29.0947 20.5822 28.7156 20.5822 28.2606V27.1421H13.4922L19.748 19.2938C19.8428 19.1801 20.0134 18.9716 20.0893 18.8768L20.1272 18.8199C20.4874 18.2891 20.5632 17.8341 20.5632 17.2844V17Z" fill="#0068FF" />
                <path d="M32.9416 29.0947H34.3255V17H32.2402V28.3933C32.2402 28.7725 32.5435 29.0947 32.9416 29.0947Z" fill="#0068FF" />
                <path d="M25.814 19.6924C23.1979 19.6924 21.0747 21.8156 21.0747 24.4317C21.0747 27.0478 23.1979 29.171 25.814 29.171C28.4301 29.171 30.5533 27.0478 30.5533 24.4317C30.5723 21.8156 28.4491 19.6924 25.814 19.6924ZM25.814 27.2184C24.2785 27.2184 23.0273 25.9672 23.0273 24.4317C23.0273 22.8962 24.2785 21.645 25.814 21.645C27.3495 21.645 28.6007 22.8962 28.6007 24.4317C28.6007 25.9672 27.3685 27.2184 25.814 27.2184Z" fill="#0068FF" />
                <path d="M40.4867 19.6162C37.8516 19.6162 35.7095 21.7584 35.7095 24.3934C35.7095 27.0285 37.8516 29.1707 40.4867 29.1707C43.1217 29.1707 45.2639 27.0285 45.2639 24.3934C45.2639 21.7584 43.1217 19.6162 40.4867 19.6162ZM40.4867 27.2181C38.9322 27.2181 37.681 25.9669 37.681 24.4124C37.681 22.8579 38.9322 21.6067 40.4867 21.6067C42.0412 21.6067 43.2924 22.8579 43.2924 24.4124C43.2924 25.9669 42.0412 27.2181 40.4867 27.2181Z" fill="#0068FF" />
                <path d="M29.4562 29.0944H30.5747V19.957H28.6221V28.2793C28.6221 28.7153 29.0012 29.0944 29.4562 29.0944Z" fill="#0068FF" />
            </svg>

        )}
        {...props}
    />
);

const TelegramIcon = (props: Partial<CustomIconComponentProps>) => (
    <Icon
        component={() => (
            <svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="50" height="50" viewBox="0 0 48 48">
                <path fill="#29b6f6" d="M24 4A20 20 0 1 0 24 44A20 20 0 1 0 24 4Z"></path><path fill="#fff" d="M33.95,15l-3.746,19.126c0,0-0.161,0.874-1.245,0.874c-0.576,0-0.873-0.274-0.873-0.274l-8.114-6.733 l-3.97-2.001l-5.095-1.355c0,0-0.907-0.262-0.907-1.012c0-0.625,0.933-0.923,0.933-0.923l21.316-8.468 c-0.001-0.001,0.651-0.235,1.126-0.234C33.667,14,34,14.125,34,14.5C34,14.75,33.95,15,33.95,15z"></path><path fill="#b0bec5" d="M23,30.505l-3.426,3.374c0,0-0.149,0.115-0.348,0.12c-0.069,0.002-0.143-0.009-0.219-0.043 l0.964-5.965L23,30.505z"></path><path fill="#cfd8dc" d="M29.897,18.196c-0.169-0.22-0.481-0.26-0.701-0.093L16,26c0,0,2.106,5.892,2.427,6.912 c0.322,1.021,0.58,1.045,0.58,1.045l0.964-5.965l9.832-9.096C30.023,18.729,30.064,18.416,29.897,18.196z"></path>
            </svg>
        )}
        {...props}
    />
);

const UserForm: React.FC = () => (
    <>
        <Form.Item
            name="phoneNumber"
            label="Số điện thoại"
            rules={[
                { required: true },
                { pattern: /^[0-9]{10}$/, message: 'Số điện thoại không hợp lệ' }
            ]}
        >
            <Input />
        </Form.Item>

        <Form.Item
            name="name"
            label="Họ tên"
            rules={[{ required: true }]}
        >
            <Input />
        </Form.Item>

        <Form.Item
            name="password"
            label="Mật khẩu"
            rules={[
                { required: true },
                { min: 6, message: 'Mật khẩu phải có ít nhất 6 ký tự' }
            ]}
        >
            <Input.Password />
        </Form.Item>
    </>
);

const dateFormat = (date: any) => {
    if (date) {
        if (date.seconds) {
            return dayjs(new Date(date.seconds * 1000)).format('DD/MM/YYYY HH:mm:ss');
        } else if (date instanceof Date) {
            return dayjs(date).format('DD/MM/YYYY HH:mm:ss');
        } else if (typeof date === 'string') {
            return dayjs(date, 'DD/MM/YYYY').format('DD/MM/YYYY HH:mm:ss');
        }
    }
    return '';
};

const UserManagement: React.FC = () => {
    const [users, setUsers] = useState<User[]>([]);
    const [loading, setLoading] = useState(false);
    const [modalVisible, setModalVisible] = useState(false);
    const [editingUser, setEditingUser] = useState<User | null>(null);
    const [form] = Form.useForm();
    const [favoritesModalVisible, setFavoritesModalVisible] = useState(false);
    const [selectedUserId, setSelectedUserId] = useState<string>('');
    const [ordersModalVisible, setOrdersModalVisible] = useState(false);
    const [selectedUserForOrders, setSelectedUserForOrders] = useState<string>('');
    const [pointsModalVisible, setPointsModalVisible] = useState(false);
    const [selectedUserPoints, setSelectedUserPoints] = useState<User['lstPoint']>([]);
    const [windowWidth, setWindowWidth] = useState(window.innerWidth);
    const isMobile = windowWidth <= 400;
    const [searchText, setSearchText] = useState('');
    const [statusFilter, setStatusFilter] = useState<string>('all');
    const [typeFilter, setTypeFilter] = useState<string>('all');
    const [syncLoading, setSyncLoading] = useState(false);
    const [tagLoadingMap, setTagLoadingMap] = useState<Record<string, boolean>>({});
    const isMountedRef = useRef(true);
    const fetchUsersRequestIdRef = useRef(0);

    // Tour state and refs
    const [isTourOpen, setIsTourOpen] = useState(false);
    const titleRef = useRef(null);
    const syncButtonRef = useRef(null);
    const searchRef = useRef(null);
    const filtersRef = useRef(null);
    const tableContainerRef = useRef(null);

    const tourSteps: TourProps['steps'] = [
        {
            title: 'Quản lý người dùng',
            description: 'Chào mừng bạn đến với trang Quản lý người dùng! Đây là nơi bạn có thể quản lý tất cả người dùng của hệ thống, theo dõi thông tin cá nhân, trạng thái theo dõi và tương tác với khách hàng.',
            target: () => titleRef.current,
        },
        {
            title: 'Đồng bộ trạng thái',
            description: 'Đồng bộ trạng thái người dùng từ các nền tảng như Zalo, Telegram để cập nhật thông tin mới nhất về việc theo dõi OA và trạng thái kết nối.',
            target: () => syncButtonRef.current,
        },
        {
            title: 'Tìm kiếm',
            description: 'Tìm kiếm nhanh người dùng theo tên hoặc số điện thoại. Nhập từ khóa và kết quả sẽ được lọc ngay lập tức.',
            target: () => searchRef.current,
        },
        {
            title: 'Bộ lọc',
            description: 'Lọc người dùng theo trạng thái quan tâm (chưa quan tâm, quan tâm, hội viên) và theo đối tượng (Zalo, Telegram). Giúp bạn dễ dàng phân loại và quản lý khách hàng.',
            target: () => filtersRef.current,
        },
        {
            title: 'Bảng dữ liệu người dùng',
            description: 'Bảng hiển thị thông tin chi tiết của tất cả người dùng bao gồm ảnh đại diện, tên, số điện thoại, trạng thái theo dõi, loại tài khoản và các thao tác như gửi tin nhắn, xem lịch sử đơn hàng, danh sách yêu thích.',
            target: () => tableContainerRef.current,
        },
        {
            title: 'Kết thúc hướng dẫn!',
            description: 'Cảm ơn bạn đã xem hướng dẫn này. Bây giờ bạn đã sẵn sàng quản lý người dùng hiệu quả. Bạn có thể theo dõi, tương tác và chăm sóc khách hàng một cách chuyên nghiệp.',
            target: () => titleRef.current,
        },
    ];

    useEffect(() => {
        const handleResize = () => setWindowWidth(window.innerWidth);
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    const fetchUsers = useCallback(async () => {
        const requestId = ++fetchUsersRequestIdRef.current;
        if (isMountedRef.current) {
            setLoading(true);
        }

        try {
            const data = await userService.getAllUsers();

            if (!isMountedRef.current || requestId !== fetchUsersRequestIdRef.current) {
                return data;
            }

            setUsers(data);
            return data;
        } catch (error) {
            console.error('Error fetching users:', error);
            if (isMountedRef.current && requestId === fetchUsersRequestIdRef.current) {
                message.error('Không thể tải danh sách người dùng');
            }
            return [] as User[];
        } finally {
            if (isMountedRef.current && requestId === fetchUsersRequestIdRef.current) {
                setLoading(false);
            }
        }
    }, []);

    useEffect(() => {
        fetchUsers();

        return () => {
            isMountedRef.current = false;
            fetchUsersRequestIdRef.current += 1;
        };
    }, [fetchUsers]);

    const getAllUsers = useCallback(async (accessToken: string): Promise<any[]> => {
        try {
            let offset = 0;
            const count = 50;
            let hasMore = true;
            const result: any[] = [];

            while (hasMore) {
                const response = await axios.get(
                    `https://openapi.zalo.me/v3.0/oa/user/getlist?data=${JSON.stringify({
                        offset,
                        count,
                    })}`,
                    {
                        headers: {
                            'access_token': accessToken
                        }
                    }
                );

                if (response.data.error === 0) {
                    const pageUsers = response.data.data.users;
                    result.push(...pageUsers);
                    if (pageUsers.length < count) {
                        hasMore = false;
                    } else {
                        offset += count;
                    }
                } else {
                    throw new Error(response.data.message);
                }
            }

            return result;
        } catch (error) {
            console.error('Error fetching users:', error);
            return [];
        }
    }, []);

    const syncZaloUserDetails = useCallback(async (zaloUserList: any[], accessToken: string): Promise<number> => {
        if (zaloUserList.length === 0) return 0;

        const dedupedUsers = Array.from(
            new Map(zaloUserList.map((user) => [user.user_id, user])).values()
        );

        const currentUsersByLocalId = new Map<string, User>();
        users.forEach((user) => {
            const localId = (user as any).localId || user.id;
            if (localId) {
                currentUsersByLocalId.set(localId, user);
            }
        });

        let updatedCount = 0;

        for (const user of dedupedUsers) {
            try {
                const response = await axios.get(
                    `https://openapi.zalo.me/v3.0/oa/user/detail?data={"user_id":"${user.user_id}"}`,
                    {
                        headers: {
                            'access_token': accessToken
                        }
                    }
                );

                if (response.data.error === 0) {
                    const zaloUserDetail: any = response.data.data;
                    const localId = zaloUserDetail.user_id_by_app;
                    const currentUser = currentUsersByLocalId.get(localId);
                    const nextTagName = zaloUserDetail.tags_and_notes_info?.tag_names?.[0] || '';
                    const nextFollowState = Boolean(zaloUserDetail.user_is_follower);
                    const nextPayload = {
                        ...user,
                        zaloUserId: zaloUserDetail.user_id,
                        tagNames: nextTagName,
                        userIsFollowed: nextFollowState
                    };

                    const shouldUpdate = !currentUser ||
                        currentUser.zaloUserId !== nextPayload.zaloUserId ||
                        (currentUser.tagNames || '') !== nextTagName ||
                        Boolean(currentUser.userIsFollowed) !== nextFollowState;

                    if (shouldUpdate) {
                        await userService.updateUserByLocalId(localId, nextPayload);
                        updatedCount += 1;
                    }
                }
            } catch (error) {
                console.error('Error fetching user detail:', error);
            }
        }

        return updatedCount;
    }, [users]);

    const handleSubmit = async (values: any) => {
        try {
            if (editingUser) {
                await userService.updateUser(editingUser.id!, values);
                message.success('Cập nhật người dùng thành công');
            } else {
                await userService.addUser(values);
                message.success('Thêm người dùng thành công');
            }
            setModalVisible(false);
            form.resetFields();
            await fetchUsers();

            // Gọi api gửi dữ liệu người dùng để AI tự động cập nhật
            // await axios.get(`https://coffee-ai.8am.vn/update`);
        } catch (error) {
            console.error('Error saving user:', error);
            message.error('Có lỗi xảy ra khi lưu thông tin');
        }
    };

    const handleDelete = async (id: string) => {
        Modal.confirm({
            title: 'Xác nhận xóa',
            content: 'Bạn có chắc chắn muốn xóa người dùng này?',
            okText: 'Xóa',
            okType: 'danger',
            cancelText: 'Hủy',
            async onOk() {
                try {
                    await userService.deleteUser(id);
                    await fetchUsers();
                    message.success('Xóa người dùng thành công');

                    // Gọi api gửi dữ liệu người dùng để AI tự động cập nhật
                    // await axios.get(`https://coffee-ai.8am.vn/update`);
                } catch (error) {
                    console.error('Error deleting user:', error);
                    message.error('Không thể xóa người dùng');
                }
            }
        });
    };

    const handleSendMessage = async (userId: string) => {
        const user = await userService.getUserById(userId);
        console.log(user);

        try {
            const configZalo = await configService.getConfig();

            const messageData = {
                recipient: {
                    user_id: user.localId
                },
                message: {
                    "attachment": {
                        "type": "template",
                        "payload": {
                            "template_type": "promotion",
                            "elements": [
                                {
                                    "attachment_id": "aERC3A0iYGgQxim8fYIK6fxzsXkaFfq7ZFRB3RCyZH6RyziRis3RNydebK3iSPCJX_cJ3k1nW1EQufjN_pUL1f6Ypq3rTef5nxp6H_HnXKFDiyD5y762HS-baqRpQe5FdA376lTfq1sRyPr8ypd74ecbaLyA-tGmuJ-97W",
                                    "type": "banner"
                                },
                                {
                                    "type": "header",
                                    "content": "💥💥Ưu đãi thành viên Platinum💥💥"
                                },
                                {
                                    "type": "text",
                                    "align": "left",
                                    "content": "Ưu đãi dành riêng cho khách hàng Nguyen Van A hạng thẻ Platinum<br>Voucher trị giá 150$"
                                },
                                {
                                    "type": "table",
                                    "content": [
                                        {
                                            "value": "VC09279222",
                                            "key": "Voucher"
                                        },
                                        {
                                            "value": "30/12/2023",
                                            "key": "Hạn sử dụng"
                                        }
                                    ]
                                },
                                {
                                    "type": "text",
                                    "align": "center",
                                    "content": "Áp dụng tất cả cửa hàng trên toàn quốc"
                                }
                            ],
                            "buttons": [
                                {
                                    "title": "Tham khảo chương trình",
                                    "image_icon": "",
                                    "type": "oa.open.url",
                                    "payload": {
                                        "url": "https://oa.zalo.me/home"
                                    }
                                },
                                {
                                    "title": "Liên hệ chăm sóc viên",
                                    "image_icon": "aeqg9SYn3nIUYYeWohGI1fYRF3V9f0GHceig8Ckq4WQVcpmWb-9SL8JLPt-6gX0QbTCfSuQv40UEst1imAm53CwFPsQ1jq9MsOnlQe6rIrZOYcrlWBTAKy_UQsV9vnfGozCuOvFfIbN5rcXddFKM4sSYVM0D50I9eWy3",
                                    "type": "oa.query.hide",
                                    "payload": "#tuvan"

                                }
                            ]
                        }
                    }
                }
            };

            const response = await axios.post(
                'https://openapi.zalo.me/v3.0/oa/message/promotion',
                messageData,
                {
                    headers: {
                        'access_token': configZalo?.access_token_zalo,
                        'Content-Type': 'application/json'
                    }
                }
            );

            if (response.data.error === 0) {
                notification.success({
                    message: 'Thành công',
                    description: 'Đã gửi tin nhắn thành công!',
                    duration: 2,
                    placement: 'top'
                });
            } else {
                throw new Error(response.data.message);
            }

        } catch (error) {
            console.error('Lỗi khi gửi tin nhắn:', error);
            notification.error({
                message: 'Lỗi',
                description: 'Không thể gửi tin nhắn. Vui lòng thử lại sau.',
                duration: 2,
                placement: 'top'
            });
        }

    };

    const handleTagChange = async (userId: string, newTagName: string) => {
        try {
            // Set loading cho user cụ thể
            setTagLoadingMap(prev => ({ ...prev, [userId]: true }));

            const currentUser = users.find(user => user.zaloUserId === userId || user.id === userId);
            if (!currentUser) return;

            const oldTagName = currentUser?.tagNames;

            if (currentUser.type !== 'TELEGRAM') {
                const newConfigZalo = await configService.getConfig();

                if (oldTagName) {
                    const untagResponse = await axios.post(
                        'https://openapi.zalo.me/v2.0/oa/tag/rmfollowerfromtag',
                        {
                            user_id: userId,
                            tag_name: oldTagName
                        },
                        {
                            headers: {
                                'Content-Type': 'application/json',
                                'access_token': newConfigZalo?.access_token_zalo
                            }
                        }
                    );

                    if (untagResponse.data.error !== 0) {
                        throw new Error('Không thể xóa nhãn cũ');
                    }
                }

                if (newTagName) {
                    const tagResponse = await axios.post(
                        'https://openapi.zalo.me/v2.0/oa/tag/tagfollower',
                        {
                            user_id: userId,
                            tag_name: newTagName
                        },
                        {
                            headers: {
                                'Content-Type': 'application/json',
                                'access_token': newConfigZalo?.access_token_zalo
                            }
                        }
                    );

                    if (tagResponse.data.error !== 0) {
                        throw new Error('Không thể gán nhãn mới');
                    }
                }
            }

            if (currentUser?.id) {
                await userService.updateUser(currentUser.id, {
                    ...currentUser,
                    tagNames: newTagName
                });
            }

            setUsers(prevUsers => prevUsers.map(user =>
                (user.zaloUserId === userId || user.id === userId)
                    ? { ...user, tagNames: newTagName }
                    : user
            ));

            notification.success({
                message: 'Thành công',
                description: newTagName
                    ? 'Đã gán nhãn cho người dùng thành công'
                    : 'Đã xóa nhãn người dùng thành công',
                duration: 2,
                placement: 'topRight'
            });

            // Gọi api gửi dữ liệu người dùng để AI tự động cập nhật
            // await axios.get(`https://coffee-ai.8am.vn/update`);

        } catch (error) {
            console.error('Error managing tags:', error);
            notification.error({
                message: 'Lỗi',
                description: 'Không thể thực hiện thao tác với nhãn người dùng',
                duration: 2,
                placement: 'topRight'
            });
        } finally {
            // Xóa loading cho user cụ thể
            setTagLoadingMap(prev => ({ ...prev, [userId]: false }));
        }
    };

    const columns: TableColumnsType<User> = [
        {
            title: 'Số điện thoại',
            dataIndex: 'phoneNumber',
            key: 'phoneNumber',
            render: (phone: string) => {
                if (phone.startsWith('84')) {
                    return `+84 ${phone.slice(2).padStart(10, '0')}`;
                }
                return phone;
            }
        },
        {
            title: 'Họ tên',
            dataIndex: 'name',
            key: 'name',
        },

        {
            title: 'Trạng thái',
            dataIndex: 'userIsFollowed',
            key: 'status',
            render: (userIsFollowed: boolean | undefined, record: User) => {
                if (record.type === 'TELEGRAM') {
                    if (record.isFollowed && record.phoneNumber) {
                        return <Tag color="success">Hội viên</Tag>;
                    }
                    if (record.isFollowed && !record.phoneNumber) {
                        return <Tag color="processing">Quan tâm</Tag>;
                    }
                    return <Tag color="default">Chưa quan tâm</Tag>;
                }
                else {
                    if (userIsFollowed && record.phoneNumber) {
                        return <Tag color="success">Hội viên</Tag>;
                    }
                    if (userIsFollowed && !record.phoneNumber) {
                        return <Tag color="processing">Quan tâm</Tag>;
                    }
                    return <Tag color="default">Chưa quan tâm</Tag>;
                }

            }
        },
        {
            title: 'Đối tượng khách hàng',
            dataIndex: 'type',
            key: 'type',
            render: (type: string) => {
                if (type === 'TELEGRAM') {
                    return <TelegramIcon style={{ fontSize: '50px', color: '#0088cc' }} />;
                }
                return <ZaloIcon style={{ fontSize: '50px', color: '#0068ff' }} />;
            }
        },
        {
            title: 'Nhãn khách hàng',
            dataIndex: 'tagNames',
            key: 'tagNames',
            render: (_: any, record: User) => {
                const userId = record.zaloUserId || record.id || '';
                return (
                    <Select
                        value={record.tagNames || ''}
                        style={{ width: 120 }}
                        onChange={(value) => handleTagChange(userId, value)}
                        options={TAG_OPTIONS}
                        loading={tagLoadingMap[userId]}
                        disabled={tagLoadingMap[userId]}
                    />
                );
            }
        },
        {
            title: 'Ngày tạo',
            dataIndex: 'createdAt',
            key: 'createdAt',
            render: (date: any) => dateFormat(date)
        },
        {
            title: 'Thao tác',
            key: 'action',
            fixed: 'right',
            render: (_: any, record: User) => (
                <Space>
                    <Tooltip title="Xem danh sách yêu thích">
                        <Button
                            icon={<HeartOutlined />}
                            onClick={() => {
                                setSelectedUserId(record.id!);
                                setFavoritesModalVisible(true);
                            }}
                        />
                    </Tooltip>
                    <Tooltip title="Xem lịch sử đơn hàng">
                        <Button
                            icon={<ShoppingCartOutlined />}
                            onClick={() => {
                                setSelectedUserForOrders(record.id!);
                                setOrdersModalVisible(true);
                            }}
                        />
                    </Tooltip>
                    <Tooltip title="Xem danh sách điểm">
                        <Button
                            icon={<StarOutlined />}
                            onClick={() => {
                                setSelectedUserPoints(record.lstPoint);
                                setPointsModalVisible(true);
                            }}
                        />
                    </Tooltip>
                    <Tooltip title="Gửi tin nhắn">
                        <Button
                            icon={<MessageOutlined />}
                            onClick={() => {
                                window.open(`https://oa.zalo.me/chatv2?uid=${record.zaloUserId}&oaid=2315491439411829194`, '_blank');
                            }}
                        />
                    </Tooltip>
                    <Tooltip title="Xóa người dùng">
                        <Button
                            icon={<DeleteOutlined />}
                            danger
                            onClick={() => handleDelete(record.id!)}
                        />
                    </Tooltip>


                </Space>
            )
        }
    ];

    const getMobileColumns = (): TableColumnsType<any> => [
        {
            title: 'Thông tin',
            dataIndex: 'phoneNumber',
            key: 'info',
            render: (_, record: any) => (
                <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
                    <div style={{ fontSize: '12px' }}>
                        <Space direction="vertical" size={4} style={{ width: '100%' }}>
                            <div>
                                <strong>Số điện thoại:</strong>{' '}
                                <Tag style={{ fontSize: '11px' }}>
                                    {record.phoneNumber.startsWith('84') ?
                                        `+84 ${record.phoneNumber.slice(2).padStart(10, '0')}` :
                                        record.phoneNumber}
                                </Tag>
                            </div>

                            <div>
                                <strong>Họ tên:</strong>{' '}
                                <Tag style={{ fontSize: '11px' }}>
                                    {record.name || 'N/A'}
                                </Tag>
                            </div>

                            <div>
                                <strong>Ngày tạo:</strong>{' '}
                                <span style={{ fontSize: '11px' }}>
                                    {dateFormat(record.createdAt)}
                                </span>
                            </div>

                            <div>
                                <strong>Trạng thái:</strong>{' '}
                                <Tag style={{ fontSize: '11px' }}>
                                    {!record.isFollowed ? 'Chưa quan tâm' :
                                        (record.isFollowed && record.phoneNumber ? 'Hội viên' : 'Quan tâm')}
                                </Tag>
                            </div>

                            <div>
                                <strong>Đối tượng:</strong>{' '}
                                <span>
                                    {record.type === 'TELEGRAM' ?
                                        <TelegramIcon style={{ fontSize: '50px', color: '#0088cc' }} /> :
                                        <ZaloIcon style={{ fontSize: '50px', color: '#0068ff' }} />
                                    }
                                </span>
                            </div>

                            <div>
                                <strong>Nhãn:</strong>{' '}
                                {record.type !== 'TELEGRAM' && record.isFollowed ? (
                                    <Select
                                        value={record.tagNames || ''}
                                        style={{ width: 120 }}
                                        onChange={(value) => handleTagChange(record.zaloUserId || record.id || '', value)}
                                        options={TAG_OPTIONS}
                                        size="small"
                                    />
                                ) : (
                                    <span>-</span>
                                )}
                            </div>
                        </Space>
                    </div>
                </div>
            )
        },
        {
            title: 'Thao tác',
            key: 'action',
            render: (_: any, record: User) => (
                <Space>
                    <Button
                        icon={<HeartOutlined />}
                        onClick={() => {
                            setSelectedUserId(record.id!);
                            setFavoritesModalVisible(true);
                        }}
                        size="small"
                    />
                    <Button
                        icon={<ShoppingCartOutlined />}
                        onClick={() => {
                            setSelectedUserForOrders(record.id!);
                            setOrdersModalVisible(true);
                        }}
                        size="small"
                    />
                    <Button
                        icon={<StarOutlined />}
                        onClick={() => {
                            setSelectedUserPoints(record.lstPoint);
                            setPointsModalVisible(true);
                        }}
                        size="small"
                    />
                    <Button
                        icon={<MessageOutlined />}
                        onClick={() => {
                            window.open(`https://oa.zalo.me/chatv2?uid=${record.zaloUserId}&oaid=2315491439411829194`, '_blank');
                        }}
                        size="small"
                    />
                    <Button
                        icon={<DeleteOutlined />}
                        danger
                        size="small"
                        onClick={() => handleDelete(record.id!)}
                    />
                </Space>
            )
        }
    ];

    const filteredUsers = useMemo(() => {
        return users.filter(user => {
            const matchesSearch = user.name?.toLowerCase().includes(searchText.toLowerCase()) ||
                user.phoneNumber.toLowerCase().includes(searchText.toLowerCase());

            let matchesStatus = true;
            switch (statusFilter) {
                case 'not_interested':
                    matchesStatus = !user.isFollowed;
                    break;
                case 'interested':
                    matchesStatus = !!user.isFollowed && !user.phoneNumber;
                    break;
                case 'member':
                    matchesStatus = !!user.isFollowed && !!user.phoneNumber;
                    break;
                default: // 'all'
                    matchesStatus = true;
            }

            let matchesType = true;
            switch (typeFilter) {
                case 'zalo':
                    matchesType = user.type !== 'TELEGRAM';
                    break;
                case 'telegram':
                    matchesType = user.type === 'TELEGRAM';
                    break;
                default: // 'all'
                    matchesType = true;
            }

            return matchesSearch && matchesStatus && matchesType;
        });
    }, [users, searchText, statusFilter, typeFilter]);

    const todayNewUsersCount = useMemo(() => {
        const today = new Date();

        return users.filter(user => {
            const timestamp = user.createdAt;
            const userDate = timestamp && typeof timestamp === 'object' && 'seconds' in timestamp
                ? new Date((timestamp.seconds as number) * 1000)
                : timestamp ? new Date(timestamp) : new Date();

            return userDate.getDate() === today.getDate() &&
                userDate.getMonth() === today.getMonth() &&
                userDate.getFullYear() === today.getFullYear();
        }).length;
    }, [users]);

    const handleSync = useCallback(async () => {
        try {
            setSyncLoading(true);

            const newConfigZalo = await configService.getConfig();
            const accessToken = newConfigZalo?.access_token_zalo;

            if (!accessToken) {
                throw new Error('Thiếu access token Zalo');
            }

            const zaloUserList = await getAllUsers(accessToken);
            const updatedCount = await syncZaloUserDetails(zaloUserList, accessToken);

            if (updatedCount > 0) {
                await fetchUsers();
            }

            notification.success({
                message: 'Thành công',
                description: `Đã đồng bộ dữ liệu thành công${updatedCount > 0 ? ` (${updatedCount} người dùng cập nhật)` : ''}`,
                duration: 2
            });
        } catch (error) {
            console.error('Error syncing:', error);
            notification.error({
                message: 'Lỗi',
                description: 'Không thể đồng bộ dữ liệu. Vui lòng thử lại sau.',
                duration: 2
            });
        } finally {
            setSyncLoading(false);
        }
    }, [fetchUsers, getAllUsers, syncZaloUserDetails]);

    return (
        <AdminLayout>
            <div className="admin-page-header">
                <div className="admin-page-title">
                    <h1 ref={titleRef}>Quản lý người dùng</h1>
                    <Tag color="blue">{users.length} người dùng</Tag>
                    <Tag color="green">{todayNewUsersCount} người dùng mới hôm nay</Tag>
                    <Button 
                        type="primary" 
                        icon={<QuestionCircleOutlined />} 
                        onClick={() => setIsTourOpen(true)}
                        style={{ marginLeft: 8 }}
                    >
                        Hướng dẫn
                    </Button>
                </div>

                <div className="admin-page-actions">
                    <div className="admin-search-filters" ref={filtersRef}>
                        <Button
                            icon={<SyncOutlined spin={syncLoading} />}
                            onClick={handleSync}
                            loading={syncLoading}
                            className="admin-button"
                            ref={syncButtonRef}
                        >
                            Đồng bộ trạng thái
                        </Button>
                        <div ref={searchRef}>
                            <Search
                                placeholder="Tìm theo tên hoặc số điện thoại"
                                allowClear
                                style={{ width: isMobile ? '100%' : 300 }}
                                onChange={(e) => setSearchText(e.target.value)}
                                className="admin-search-input"
                            />
                        </div>
                        <Select
                            defaultValue="all"
                            style={{ width: isMobile ? '100%' : 200 }}
                            onChange={(value) => setStatusFilter(value)}
                            className="admin-select"
                        >
                            <Option value="all">Tất cả trạng thái</Option>
                            <Option value="not_interested">Chưa quan tâm</Option>
                            <Option value="interested">Quan tâm</Option>
                            <Option value="member">Hội viên</Option>
                        </Select>
                        <Select
                            defaultValue="all"
                            style={{ width: isMobile ? '100%' : 200 }}
                            onChange={(value) => setTypeFilter(value)}
                            className="admin-select"
                        >
                            <Option value="all">Tất cả đối tượng</Option>
                            <Option value="zalo">Zalo</Option>
                            <Option value="telegram">Telegram</Option>
                        </Select>
                    </div>
                </div>
            </div>

            <div className="admin-table-container" ref={tableContainerRef}>
                <Table
                    className="admin-table"
                    columns={isMobile ? getMobileColumns() : columns}
                    dataSource={filteredUsers}
                    loading={loading}
                    rowKey="id"
                    scroll={{ x: isMobile ? undefined : 1500 }}
                    pagination={{
                        responsive: true,
                        defaultPageSize: isMobile ? 5 : 10,
                        position: isMobile ? ['bottomCenter'] : ['bottomRight']
                    }}
                />
            </div>

            <Modal
                title={editingUser ? "Sửa thông tin người dùng" : "Thêm người dùng mới"}
                visible={modalVisible}
                onCancel={() => {
                    setModalVisible(false);
                    form.resetFields();
                }}
                footer={null}
                className="admin-modal"
            >
                <div className="admin-form-container">
                    <div className="admin-form-section">
                        <h3 className="admin-form-section-title">Thông tin người dùng</h3>
                        <Form
                            form={form}
                            layout="vertical"
                            onFinish={handleSubmit}
                        >
                            <UserForm />
                            <Form.Item>
                                <Button type="primary" htmlType="submit" className="admin-button">
                                    {editingUser ? 'Cập nhật' : 'Thêm mới'}
                                </Button>
                            </Form.Item>
                        </Form>
                    </div>
                </div>
            </Modal>

            <FavoritesModal
                visible={favoritesModalVisible}
                userId={selectedUserId}
                onClose={() => setFavoritesModalVisible(false)}
            />

            <OrdersModal
                visible={ordersModalVisible}
                userId={selectedUserForOrders}
                onClose={() => setOrdersModalVisible(false)}
            />

            <Modal
                title="Danh sách điểm"
                visible={pointsModalVisible}
                onCancel={() => setPointsModalVisible(false)}
                footer={null}
                width={isMobile ? '100%' : 800}
                className="admin-modal"
            >
                <div className="admin-form-container">
                    <div className="admin-form-section">
                        <h3 className="admin-form-section-title">Chi tiết điểm</h3>
                        <Table
                            className="admin-table"
                            columns={isMobile ? [
                                {
                                    title: 'Thông tin',
                                    key: 'info',
                                    render: (record: any) => (
                                        <Space direction="vertical" size={4} style={{ width: '100%' }}>
                                            <div>
                                                <strong>Mã điểm:</strong>{' '}
                                                <Tag style={{ fontSize: '11px' }}>{record.orderId}</Tag>
                                            </div>
                                            <div>
                                                <strong>Số điểm:</strong>{' '}
                                                <Tag color="blue" style={{ fontSize: '11px' }}>{record.point}</Tag>
                                            </div>
                                            <div>
                                                <strong>Ngày tạo:</strong>{' '}
                                                <div style={{ fontSize: '11px' }}>{dateFormat(record.date)}</div>
                                            </div>
                                        </Space>
                                    )
                                }
                            ] : [
                                { title: 'Mã điểm', dataIndex: 'orderId', key: 'orderId' },
                                { title: 'Số điểm', dataIndex: 'point', key: 'point' },
                                { title: 'Ngày tạo', dataIndex: 'date', key: 'date', render: (date: any) => dateFormat(date) }
                            ]}
                            dataSource={selectedUserPoints}
                            rowKey="orderId"
                            pagination={{
                                defaultPageSize: isMobile ? 5 : 10,
                                position: isMobile ? ['bottomCenter'] : ['bottomRight']
                            }}
                        />
                    </div>
                </div>
            </Modal>

            {/* Tour component */}
            <ConfigProvider locale={viVN}>
                <Tour
                    open={isTourOpen}
                    onClose={() => setIsTourOpen(false)}
                    steps={tourSteps}
                    indicatorsRender={(current, total) => (
                        <span>{current + 1} / {total}</span>
                    )}
                    type="primary"
                    arrow={true}
                    placement="bottom"
                    mask={{
                        style: {
                            boxShadow: 'inset 0 0 15px #333',
                        },
                    }}
                />
            </ConfigProvider>
        </AdminLayout>
    );
};

export default UserManagement;